import { memo } from "react";

export type Playing = { title: string; artist: string; art?: string; device?: string };

// Carte "en lecture" : jaquette + titre (retour visuel ; le son sort du téléphone
// par défaut, ou d'Alexa). Un bouton 📱/🔊 bascule la sortie. Thémée via --kid-*.
export const NowPlaying = memo(function NowPlaying({
  playing,
  target = "phone",
  onToggle,
}: {
  playing: Playing | null;
  target?: "phone" | "alexa";
  onToggle?: () => void;
}) {
  if (!playing) return null;
  return (
    <div
      style={{
        // Docké AU-DESSUS des contrôles du bas (tuiles JEUX/COLLECTION à gauche jusqu'à
        // ~safe+138px, glyphe à droite jusqu'à ~120px) → même base safe-area que les tuiles
        // pour qu'ils bougent ensemble. Verticalement au-dessus d'eux = zéro chevauchement.
        position: "absolute",
        left: "50%",
        bottom: "calc(max(14px, env(safe-area-inset-bottom)) + 150px)",
        transform: "translateX(-50%)",
        zIndex: 30,
        display: "flex",
        alignItems: "center",
        gap: 10,
        maxWidth: "min(82vw, 360px)",
        padding: "8px 16px 8px 8px",
        background: "rgba(0,0,0,0.55)",
        border: "1px solid var(--kid-cyan, #29e0ff)",
        borderRadius: 14,
        backdropFilter: "blur(6px)",
        boxShadow: "0 0 18px rgba(0,0,0,0.45)",
      }}
    >
      {playing.art ? (
        <img src={playing.art} alt="" width={46} height={46} style={{ borderRadius: 8, flex: "0 0 auto" }} />
      ) : (
        <div style={{ width: 46, height: 46, borderRadius: 8, display: "grid", placeItems: "center", background: "rgba(255,255,255,0.08)", fontSize: 22, flex: "0 0 auto" }}>🎵</div>
      )}
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 11, letterSpacing: 1, opacity: 0.75, color: "var(--kid-cyan, #29e0ff)" }}>
          ♪ EN LECTURE
        </div>
        <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "#fff" }}>{playing.title}</div>
        <div style={{ fontSize: 12, opacity: 0.85, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "#fff" }}>{playing.artist}</div>
      </div>
      {onToggle && (
        <button
          onClick={onToggle}
          aria-label={target === "phone" ? "Envoyer sur Alexa" : "Ramener sur le téléphone"}
          title={target === "phone" ? "Sur le téléphone — toucher pour envoyer sur Alexa" : "Sur Alexa — toucher pour ramener sur le téléphone"}
          style={{
            flex: "0 0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            background: "rgba(255,255,255,0.08)",
            border: "1px solid var(--kid-cyan, #29e0ff)",
            borderRadius: 10,
            color: "var(--kid-cyan, #29e0ff)",
            padding: "6px 10px",
            cursor: "pointer",
            fontFamily: "var(--kid-font-mono, monospace)",
            fontSize: 10,
            letterSpacing: 1,
          }}
        >
          <span style={{ fontSize: 18, lineHeight: 1 }}>{target === "phone" ? "📱" : "🔊"}</span>
          {target === "phone" ? "TÉL." : "ALEXA"}
        </button>
      )}
    </div>
  );
});
